import { render, staticRenderFns } from "./StaticText.vue?vue&type=template&id=99730520"
import script from "./StaticText.vue?vue&type=script&lang=js"
export * from "./StaticText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports